import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_all_added_skills_hiring_manager_action,
  get_all_skills_action,
  search_mentor_action,
} from "../../../redux/_actions";

function useAllMentors() {
  const [suggestedMentorsLoading, setSuggestedMentorsLoading] = useState(false);
  const [suggestedMentors, setSuggestedMentors] = useState([]);
  const [mentorSelectedSkill, setMentorSelectedSkill] = useState([]);
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [mentorLoading, setMentorLoading] = useState(false);
  const [mentorSearch, setMentorSearch] = useState(null);
  const [showSkillSearch, setShowSkillSearch] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchInputRef = useRef();
  const searchInputSkillRef = useRef();

  const { allAddedSkillsData } = useSelector(
    (state) => state.get_all_added_skills_hiring_manager_reducer
  );

  const { searchMentorData } = useSelector(
    (state) => state.search_mentor_reducer
  );

  const { allSkillsData } = useSelector(
    (state) => state.get_all_skills_reducer
  );

  useEffect(() => {
    callSkillsApi();
  }, []);

  useEffect(() => {
    if (allSkillsData?.data) {
      setSkillsTagsAdded(allSkillsData?.data);
    }
  }, [allSkillsData]);

  useEffect(() => {
    if (searchMentorData?.data) {
      setSuggestedMentors(searchMentorData?.data);
    }
  }, [searchMentorData]);

  useEffect(() => {
    getSuggestedMentorsApi();
  }, [searchInputValue , mentorSelectedSkill]);

  useEffect(() => {
    if (allAddedSkillsData?.data) {
      setSkillsTagsAdded(allAddedSkillsData.data?.results);
    }
  }, [allAddedSkillsData]);


  const callSkillsApi = async (value) => {
    setSkillsListLoading(true);
    const data = { index: "skill", search_key: "", search: value ? value : "" };
    await dispatch(get_all_skills_action(data));
    setSkillsListLoading(false);
  };

  const onMentorJobsSkillsChange = (skill, isAlreadyListed) => {
    const skillToAdd = isAlreadyListed ? skill : skill?.skill.toLowerCase();
    if (!mentorSelectedSkill.includes(skillToAdd)) {
      setMentorSelectedSkill([...mentorSelectedSkill, skillToAdd]);
    }
  };

  const onMentorSkillUnselectClick = (skill, isAlreadyListed) => {
    const skillToRemove = isAlreadyListed ? skill : skill?.skill.toLowerCase();
    if (mentorSelectedSkill.includes(skillToRemove)) {
      const filteredSkills = mentorSelectedSkill.filter(
        (item) => item !== skillToRemove
      );
      setMentorSelectedSkill(filteredSkills);
    }
  };

  const getSuggestedMentorsApi = async () => {
    const data = {
      index: "mentor_profile",
      search_key: "",
      search: searchInputValue ? searchInputValue : "",
      skill_names: mentorSelectedSkill.length
        ? mentorSelectedSkill
        : searchInputValue
        ? []
        : "",
    };
    setSuggestedMentorsLoading(true);
    const res = await dispatch(search_mentor_action(data));
    setSuggestedMentorsLoading(false);
  };

  const onViewMentorProfileClick = (id) => {
    if (id)
      navigate(`/mentor-profile/${id}`, {
        state: { id: id },
      });
  };

  const onViewAllAppliedMentor = () => {
    navigate("/all-applied-mentors");
  };

  const onSearch = () => {
    if (showSearch) {
      searchInputRef.current.value = "";
    }
    setShowSearch((showSearch) => !showSearch);
    setSearchInputValue("");
    setMentorSelectedSkill([]);
  };

  const onSkillSearch = () => {
    if (showSkillSearch) {
      if (searchInputSkillRef.current) {
        searchInputSkillRef.current.value = "";
      }
    }
    setShowSkillSearch((showSkillSearch) => !showSkillSearch);
    callSkillsApi();
  };

  const onSearchInputChange = async (e) => {
    let value = e.target.value;

    if (value.length > 2) {
      setShowSearch(true);
      setSearchInputValue(value);
    } else if (!value.length) {
      onSearch();
    }
  };
  const onHandleClearTags = () => {
    setMentorSelectedSkill([]);
  };

  const checkSelectedTag = (tag, isAlreadyListed) => {
    const tagToCheck = isAlreadyListed ? tag : tag?.skill.toLowerCase();
    return mentorSelectedSkill.includes(tagToCheck);
  };

  const onSearchSkillChange = (e) => {
    let value = e.target.value;
    if (value.length > 2) {
      setShowSkillSearch(true);
      callSkillsApi(value);
    }
  };

  return {
    skillsTagsAdded,
    suggestedMentorsLoading,
    suggestedMentors,
    mentorSelectedSkill,
    skillsListLoading,
    showSearch,
    searchInputRef,
    mentorLoading,
    mentorSearch,
    showSkillSearch,
    searchInputSkillRef,
    onSkillSearch,
    onMentorJobsSkillsChange,
    onMentorSkillUnselectClick,
    onViewMentorProfileClick,
    onViewAllAppliedMentor,
    onSearchInputChange,
    onSearch,
    onHandleClearTags,
    checkSelectedTag,
    onSearchSkillChange,
  };
}

export default useAllMentors;
